import { ALIGN_CLASSES_INVERSE as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
import { centerable as n } from "../decorators/centerable.js";
import { stylable as r } from "../decorators/stylable.js";
import "../decorators.js";
var i = r(n({
	inline: !1,
	content: "inline*",
	group: "block",
	attrs: t({ type: { default: "paragraph" } }),
	parseDOM: [{
		tag: "p",
		getAttrs(t) {
			let n;
			return t.parentElement && t.parentElement.classList.forEach((t) => {
				t in e && (n = e[t]);
			}), { alignment: n };
		}
	}],
	toDOM() {
		return ["p", 0];
	}
}));
//#endregion
export { i as paragraphSpec };
